import baguetteBox from '../functions/baguettebox';
import lazyJs from '../functions/lazyJs';
import { EMBLA_JS_FILE, EMBLA_LOADED_VAR } from '../config/main';
import { querySelector, querySelectorAll } from '../functions/querySelectors';
import { setListenersFromSelector } from '../functions/listeners';
import { DEFAULT_TRANSITION_TIME } from '../config/main';
import alert from '../modules/alert';

export const ROOT_CLASS = 'c-product-gallery';
export const IMAGES_CLASS = 'c-product-embla__images';
const MAIN_WRAP_CLASS = 'js-product-main-wrap';
const MAIN_LINK_CLASS = 'js-product-main-link';
const MAIN_LINK_INIT_CLASS = 'jpml-init';
export const THUMB_IMAGE_CLASS = 'js-product-image-thumb';
const THUMB_IMAGE_INIT_CLASS = 'jpit-init';
const IMAGE_ID_ATTR = 'data-image-id';
export const THUMB_ACTIVE_CLASS = 'c-product-embla__image-link--active';
const VIDEO_CLASS = 'js-product-video';
const VIDEO2_CLASS = 'js-product-video2';
const VIDEO_INIT_CLASS = 'jpv-init';
const VIDEO_ID_ATTR = 'data-video-id';
const MAIN_VIDEO_CLASS = 'c-product-gallery__main-video';
const ROOT_VIDEO_CLASS = 'c-product-gallery--video';
const TAGS_CLASS = 'c-product-gallery__tags';
const PRINC_CLASS = 'c-product-gallery__princ';

let galleryInstance = null;
window.imagesArray = window.imagesArray ? window.imagesArray : [];

let getRootElement = function() {
  return querySelector(`.${ROOT_CLASS}`);
};

let getMainWrap = function() {
  return querySelector(`.${MAIN_WRAP_CLASS}`);
};

let resolveEcoTags = function(imageId) {
  let wrapper = querySelector(`.${TAGS_CLASS}`);
  let link = querySelector(`.${THUMB_IMAGE_CLASS}[${IMAGE_ID_ATTR}="${imageId}"][data-metal-first]`);

  if (wrapper) {
    if (link) {
      wrapper.style.opacity = 1;
    }
    else {
      wrapper.style.opacity = 0;
    }
  }
};

let resolvePrinc = function(imageId) {
  let wrapper = querySelector(`.${PRINC_CLASS}`);
  let link = querySelector(`.${THUMB_IMAGE_CLASS}[${IMAGE_ID_ATTR}="${imageId}"][data-metal-first]`);

  if (wrapper) {
    if (link) {
      wrapper.style.opacity = 1;
    }
    else {
      wrapper.style.opacity = 0;
    }
  }
};

let setActive = function(id) {
  let selectedImage = querySelector(`.${THUMB_IMAGE_CLASS}[${IMAGE_ID_ATTR}="${id}"]`);
  let selectedImageUrl = selectedImage.getAttribute('src');
  let main = getMainWrap();
  let link = querySelector('a', main);
  let image = querySelector('img', main);
  let imageClone = image.cloneNode(true);
  let active = querySelector(`.${THUMB_ACTIVE_CLASS}`);
  let video = querySelector(`.${MAIN_VIDEO_CLASS}`);

  if (video) {
    getRootElement().classList.remove(ROOT_VIDEO_CLASS);
    video.parentNode.removeChild(video);

    setTimeout(function() {
      link.style.opacity = 1;
    }, DEFAULT_TRANSITION_TIME);
  }

  image.style.opacity = 0;
  imageClone.style.opacity = 0;
  link.appendChild(imageClone);
  imageClone.setAttribute('src', selectedImageUrl);
  link.setAttribute(IMAGE_ID_ATTR, selectedImage.getAttribute(IMAGE_ID_ATTR));

  if (active) {
    active.classList.remove(THUMB_ACTIVE_CLASS);
  }

  resolveEcoTags(id);
  resolvePrinc(id);

  setTimeout(function() {
    imageClone.style.opacity = 1;

    if (image && image.parentNode) {
      image.parentNode.removeChild(image);
    }

    selectedImage.parentNode.classList.add(THUMB_ACTIVE_CLASS);
  }, DEFAULT_TRANSITION_TIME);
};

let videoClick = function(event) {
  event.preventDefault();

  let wrapper = getMainWrap();
  let link = querySelector('a', wrapper);
  link.style.opacity = 0;

  let iframe = document.createElement('div');
  iframe.classList.add(MAIN_VIDEO_CLASS);
  iframe.innerHTML = `<div><iframe width="560" height="315" src="//www.youtube.com/embed/${this.getAttribute(VIDEO_ID_ATTR)}?autoplay=1" allow="autoplay" frameborder="0" allowfullscreen></iframe></div>`;
  wrapper.appendChild(iframe);

  getRootElement().classList.add(ROOT_VIDEO_CLASS);
};

let video2Click = function(event) {
  event.preventDefault();

  let videoSize = getVideo2Size();

  alert.open({
    html: `<a href="#" class="l-alert__close js-alert-close"><svg class="svg-icon icon-cross"><use xlink:href="/assets/svg.svg#icon-cross"></use></svg></a>
    <div class="c-detail-video-iframe">
      <iframe src="${this.getAttribute('data-url')}${videoSize}/${videoSize}" border="" width="${videoSize}" height="${videoSize}">
    </div>`,
    modifs: ['detail-video-iframe']
  });
};

let getVideo2Size = function() {
  return window.innerWidth < 808 ? window.innerWidth - 28 : 780;
};

let mainImageClick = function(event) {
  event.preventDefault();

  baguetteBox.show(window.imagesArray.indexOf(this.getAttribute(IMAGE_ID_ATTR)), galleryInstance[0]);
};

let thumbClick = function(event) {
  event.preventDefault();
  event.stopPropagation();

  setActive(this.getAttribute(IMAGE_ID_ATTR), 10);
};

let setThumbsClick = function() {
  setListenersFromSelector(
    `.${THUMB_IMAGE_CLASS}`,
    THUMB_IMAGE_INIT_CLASS,
    thumbClick
  );
};

let setMainImageClick = function() {
  setListenersFromSelector(
    `.${MAIN_LINK_CLASS}`,
    MAIN_LINK_INIT_CLASS,
    mainImageClick
  );
};

let setVideos = function() {
  setListenersFromSelector(
    `.${VIDEO_CLASS}`,
    VIDEO_INIT_CLASS,
    videoClick
  );

  setListenersFromSelector(
    `.${VIDEO2_CLASS}`,
    `i-${VIDEO2_CLASS}`,
    video2Click
  );
};

export function productGallery() {
  let images = querySelectorAll(`.${THUMB_IMAGE_CLASS}`);

  if (images.length) {
    images.forEach((image) => {
      window.imagesArray.push(image.getAttribute(IMAGE_ID_ATTR));
    });

    lazyJs(EMBLA_JS_FILE, EMBLA_LOADED_VAR);

    setThumbsClick();
    setMainImageClick();
    setVideos();

    galleryInstance = baguetteBox.run(`.${IMAGES_CLASS}`);
  }
}
